const story = {

    elements: {},

    resize()
    {
        const outerWidth = this.elements.outer.offsetWidth;
        const innerWidth = this.elements.inner.offsetWidth;
        const left = (outerWidth - innerWidth) / 4;
        
        this.elements.share.style.setProperty('--share-transform-left', left + "px");
    },

    cacheDom()
    {
        this.elements.outer = document.querySelector('.js-story-outer');
        this.elements.inner = document.querySelector('.js-story-inner');
        this.elements.share = document.querySelector('.js-share');
    },

    bind()
    {
        if( this.elements.outer && this.elements.inner && this.elements.share )
        {
            this.resize();
            window.addEventListener( 'resize', this.resize.bind(this) );
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default story;